import script from "./LoaderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderPage.vue?vue&type=style&index=0&id=1eba756f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eba756f"]])

export default __exports__